import KsAjax from 'ksc-vue-ui2/src/services/KsAjax';
import Vue from 'vue';
import { colsChecked } from '../kec/constants';
export default {
    apiList: {
        oldConsole: 'http://www.ksyun.com'
    },
    basicAjax: function(data, callback) {
        if (!data.qs) data.qs = {};
        data.qs.source = 'kec';
        let ajaxData = data.qs;
        if (data.method === 'post') {
            ajaxData = [
                data.qs || {source: 'kec'},
                data.data || {}
            ];
        }
        return new Promise((resolve, reject) => {
            // Vue[data.uri] = KsAjax[data.method](data.baseUrl + data.uri, ajaxData, data.options);
            Vue[data.uri] = KsAjax[data.method](data.uri, ajaxData, data.options);
            Vue[data.uri].done((res) => {
                console.log(res, 123123123);
                //basic机房返回值3种:code、status、Return
                let codeIsOk = res && (res.code == 200 || res.Return === true);
                let statusIsOk = res && (res.status == 200 || res.status === 0);
                let dataIsNotEmpty = !_.isEmpty(res.data);
                let allInstantcesOk = res && res.InstancesSet && _.every(res.InstancesSet, item => item.Return);
                let hasProductId = res && res.ProductId;
                // if (res && (res.code == 200) || res && (res.status == 0) || !_.isEmpty(res.data) || res && res.InstancesSet && _.every(res.InstancesSet, (item) => {return item.Return})) {
                // console.log(codeIsOk, statusIsOk, dataIsNotEmpty, allInstantcesOk, hasProductId, 'aaa')
                if (codeIsOk || statusIsOk || dataIsNotEmpty || allInstantcesOk || hasProductId) {
                    if (_.isFunction(callback)) {res = callback.call(this, res);}
                    // if(res.webstatus == 500 || res.code != 200) {
                    //     reject(res.message || res.msg || Vue.$trans(`操作失败`));
                    // } else {
                    console.log(res, 111111)
                        resolve(res || {});
                    // }
                } else {
                    reject(res.message || res.msg || Vue.$trans(`操作失败`));
                }
            }).fail((c, e) => {
                console.log(c, e, 11112222);
                reject(e);
            });
        });
    },
    //硬盘
    DescribeLocalVolumes: function(params) {
        //保持统一，让列表接口支持id搜索
        if (_.get(params, 'data.LocalVolumeId')) {
            return this._getDiskInfo(params);
        }
        var data = {
            uri: '/console/localdisk/api/list',
            baseUrl: this.apiList.oldConsole,
            method: 'get',
            qs: {
                region: _.get(params, 'params.BasicRegion'),
                offset: _.get(params, 'data.Marker', 0),
                limit: _.get(params, 'data.MaxResults', 10),
                diskName: _.get(params, 'data.Search', '')
            }
        }
        var callback = function(res) {
            var ret = {};
            var data = res.data;
            ret.LocalVolumeCount = data.totalCount;
            ret.LocalVolumeSet = _.map(data.disks, _.bind(this._convertDiskList, this));
            return ret;
        }

        return this.basicAjax(data, callback);
    },

    //硬盘详情
    _getDiskInfo: function(params) {
        var data = {
            uri: '/console/localdisk/api/diskInfo',
            method: 'get',
            baseUrl: this.apiList.oldConsole,
            qs: {
                region: _.get(params, 'params.BasicRegion'),
                diskId: _.get(params, 'data.LocalVolumeId')
            }
        };
        var callback = function(data) {
            var ret = {};
            data = data.data;
            ret.LocalVolumeCount = 1;
            ret.LocalVolumeSet = _.map([data], _.bind(this._convertDiskList, this));
            return ret;
        }
        return this.basicAjax(data, callback);
    },

    //创建快照
    CreateLocalVolumeSnapshot: function(params) {
        var data = {
            uri: '/console/localdisk/api/backup/' +
                _.get(params, 'data.LocalVolumeCategory') + '/' +
                _.get(params, 'data.InstanceId'),
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: {
                region: _.get(params, 'params.BasicRegion'),
                serverId: _.get(params, 'data.InstanceId', ''),
                diskType: _.get(params, 'data.LocalVolumeCategory', ''),
                name: _.get(params, 'data.LocalVolumeSnapshotName', ''),
                description: _.get(params, 'data.LocalVolumeSnapshotDesc', '')
            },
            body: {}
        }
        var callback = function(res) {
            return res.data;
        }
        return this.basicAjax(data, callback);
    },

    _convertDiskList: function(item) {
        return this.convertKeys(item, {
            CreationDate: 'createTime',
            InstanceId: 'serverId',
            InstanceName: 'serverName',
            InstanceState: 'serverState',
            LocalVolumeId: 'diskId',
            LocalVolumeCategory: 'diskType',
            LocalVolumeName: 'diskName',
            LocalVolumeSize: 'diskSize',
            LocalVolumeState: 'state',
            LocalVolumeType: 'diskProperty',
            ServiceEndTime: function(data) {
                return new Date(data.endTime).getTime();
            }
        });
    },

    //快照列表
    DescribeLocalVolumeSnapshots: function(params) {
        var data = {
            uri: '/console/localdisk/api/backup/list',
            baseUrl: this.apiList.oldConsole,
            method: 'get',
            qs: {
                region: _.get(params, 'params.BasicRegion'),
                offset: _.get(params, 'data.Marker', 0),
                limit: _.get(params, 'data.MaxResults', 10),
                backupName: _.get(params, 'data.Search', '')
            }
        };
        var callback = function(data) {
            var ret = {};
            data = data.data;
            ret.LocalVolumeSnapshotCount = data.totalCount;
            ret.LocalVolumeSnapshotSet = _.map(data.backup, (item) =>{
                return this.convertKeys(item, {
                    CreationDate: 'createTime',
                    InstanceId: 'serverId',
                    LocalVolumeSnapshotDesc: 'description',
                    LocalVolumeSnapshotId: 'id',
                    LocalVolumeSnapshotName: 'name',
                    SourceLocalVolumeCategory: 'diskType',
                    SourceLocalVolumeId: 'diskId',
                    SourceLocalVolumeName: 'diskName',
                    SourceLocalVolumeState: 'diskState',
                    State: 'status'
                });
            });
            return ret;
        };
        return this.basicAjax(data, callback);
    },

    //删除快照
    DeleteLocalVolumeSnapshot: function(params) {
        var data = {
            uri: '/console/localdisk/api/snapshot/delete',
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: {
                region: _.get(params, 'params.BasicRegion'),
                rootSnapshotIds: _.get(params, 'data.rootSnapshotIds'),
                ephemeralSnapshotIds: _.get(params, 'data.ephemeralSnapshotIds')
            },
            // 一定要将body置为空对象
            body: {}
        };
        var callback = function(res) {
            return res.data;
        }
        return this.basicAjax(data, callback);
    },

    //回滚快照
    RollbackLocalVolume: function(params) {
        var data = {
            uri: '/console/localdisk/api/snapshot/rollback',
            method: 'post',
            baseUrl: this.apiList.oldConsole,
            data: {
                snapshotId: _.get(params, 'data.LocalVolumeSnapshotId'),
                serverId: _.get(params, 'data.serverId'),
                diskType: _.get(params, 'data.diskType'),
                region: _.get(params, 'params.BasicRegion')
            },
            body: {}
        }

        var callback = function(res) {
            res.data = {Return: true}; //兼容vpc机房
            return res.data;
        }
        return this.basicAjax(data, callback);
    },

    //镜像列表
    DescribeImages: function(params) {
        var data = {
            uri: '/console/snapshot/v3/list',
            baseUrl: this.apiList.oldConsole,
            method: 'get',
            qs: {
                pageIndex: 1,
                pageSize: 99999,
                Region: _.get(params, 'params.BasicRegion')
            }
        };
        var callback = function(res) {
            var ret = {};
            var data = res.data;
            ret.ImagesSet = _.map(data.snapshotList, function(item) {
                return this.convertKeys(item, {
                    CreationDate: 'createTime',
                    ImageId: 'snapshotId',
                    ImageState: 'snapshotState',
                    InstanceId: 'vmId',
                    IsNpe: false,
                    IsPublic: false,
                    Name: 'snapshotName',
                    Platform: 'imageName',
                    instanceName: 'vmName'
                });
            }.bind(this));
            return ret;
        }
        return this.basicAjax(data, callback);
    },

    //修改镜像名称
    ModifyImageName: function(params) {
        var data = {
            uri: '/console/snapshot/v3/updateName',
            baseUrl: this.apiList.oldConsole,
            method: 'get',
            qs: {
                imageId: _.get(params, 'params.imageId'),
                name: _.get(params, 'params.name'),
                Region: _.get(params, 'params.Region'),
                BasicRegion: _.get(params, 'params.BasicRegion')
            }
        }
        var callback = function(res) {
            var ret = {};
            var data = res.data;
            ret.Return = true;
            return ret;
        }

        return this.basicAjax(data, callback);
    },

    //删除镜像
    RemoveImages: function(params) {
        var data = {
            uri: '/console/snapshot/v3/delete',
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: {
                ImageIdList: _.get(params, 'data.ImageIdList')
            },
            options: {
                isJSON: true
            }
        }
        var callback = function(res) {
            var ret = {};
            ret.code = 200;
            ret.result = [{
                ReturnSet: [{Return: true}]
            }];
            return ret;
        }
        return this.basicAjax(data, callback);
    },

    convertKeys: function(obj, keys) {
        _.each(keys, function(oldKey, newKey) {
            if (_.isString(oldKey)) {
                obj[newKey] = obj[oldKey];
                delete obj[oldKey];
            } else if (_.isFunction(oldKey)) {
                obj[newKey] = oldKey(obj);
            }
        });
        return obj;
    },

    //重装系统
    ModifyInstanceImage: function (params) {
        var data = {
            uri: '/console/vm',
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: {
                InstancesIdList: _.get(params, 'data.InstancesIdList'),
                ImageID: _.get(params, 'data.imageID'),
                PassWord: _.get(params, 'data.passWord'),
                IsImagePublic: _.get(params, 'data.IsImagePublic')
            },
            qs: params.params,
            options: {
                isJSON: true
            }
        };
        var callback = function(res) {
            var ret = {};
            ret.code = 200;
            return ret;
        }
        debugger;
        return this.basicAjax(data, callback);
    },
    //升级配置
    updateKVM: function(params) {
        var data = {
            uri: '/console/product/CreateProduct',
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: {
                kvm: params.data
            },
            qs: params.params,
            options: {
                isJSON: true
            }
        };
        var callback = function(res) {
            var json = res.kvm;
            json.code = json.code === undefined ? json.status : json.code;
            if (json.code == 200) {
                json.tradeResult = {
                    data: json.data
                };
            } else {
                json.Error = {
                    Message: json.message
                }
            }
            return json;
        }
        return this.basicAjax(data, callback);
    },
    //计算续费价格
    // CalculateRenewal: function(params) {
    //     var data = {
    //         uri: '/api',
    //         baseUrl: this.apiList.oldConsole,
    //         method: 'post',
    //         data: params.data,
    //         qs: params.params,
    //         options: {
    //             isJSON: true
    //         }
    //     };
    //     var callback = function(res) {
    //         return res;
    //     }
    //     return this.basicAjax(data, callback);
    // },
    //购买主机
    CreateProduct: function(params) {
        if(params.params.Service == 'eip') {
            var eipData = {
                uri: params.basePath,
                baseUrl: this.apiList.oldConsole,
                method: 'get',
                qs: params.params,
                options: {
                    isJSON: true
                }
            }
            var cb = function(res) {
                return res;
            }
            return this.basicAjax(eipData, cb);
        }
        var data = {
            uri: '/console/product/CreateProduct',
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: {
                kvm: params.data
            },
            qs: params.params,
            options: {
                isJSON: true
            }
        };
        var callback = function(res) {
            return res;
        }
        return this.basicAjax(data, callback);
    },
    DescribeInstances: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    AssociateAddress: function (params) {
        return this.proxyPass('/console/vm', params);
    },

    DisassociateAddress: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    DescribeIdleEIPList: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    StartInstances: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    StopInstances: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    RebootInstances: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    ModifyInstanceName: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    GetInstanceByIds: function(params) {
        return this.proxyPass('/console/vm', params);
    },
    TerminateInstances: function (params) {
        return this.proxyPass('/console/vm', params);
    },
    proxyPass: function(url, params) {
        if(params.params.Action == 'GetInstanceByIds') {
            params.params.Action = 'GetInstanceById';
            params.params.InstanceId = params.data.InstanceId;
        }
        //兼容大米 新版接口改成+s,且basic机房接口之前为get
        var data = {
            uri: url,
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: params.data,
            qs: params.params,
            options: {
                isJSON: true,
                showLoading: _.get(params, 'options.showLoading', true)
            }
        };
        var callback = function(res) {
            if(res.Return === false) {
                res.code = 201;
                res.msg = res.Message;
            }
            return res;
        };
        return this.basicAjax(data, callback);
    },
    ModifyInstancePasswd: function(params) {
        params.params.Password = params.params.passwd;
        var data = {
            uri: '/console/vm',
            baseUrl: this.apiList.oldConsole,
            data: params.data,
            method: 'post',
            qs: params.params,
            options: {
                isJSON: true
            }
        };
        var callback = function(res) {
            if(!res) {
                res.webstatus = 500;
            }
            //由于新版控制重置密码为异步操作, 不接收返回值, 这里重置密码失败直接返回500
            if (res.Return === false) {
                res.webstatus = 500;
            }
            return res;
        };
        return this.basicAjax(data, callback);
    },
    QueryEipPackage: function(params) {
        params.params.region = params.params.BasicRegion;
        var data = {
            uri: '/console/api/eip/getLines',
            baseUrl: this.apiList.oldConsole,
            method: 'get',
            qs: params.params,
        };
        var callback = function(res) {
            if(!res) {
                res.webstatus = 500;
                res.msg = 'Internal Server Error!!';
            }
            //接口请求失败转换
            var result = {};
            if (res.status !== 0) {
                result.code = 200;
                result.msg = res.message;
                result.result = true;
                result.LineSet = res.returnEntity.data
            }
            if (res.status == 0) {
                result.code = 200;
                result.result = true;
                result.LineSet = res.returnEntity.data
            } //格式兼容
            return result;
        };
        return this.basicAjax(data, callback);
    },
    CreateImage: function(params) {

        var data = {
            uri: '/console/snapshot/v3/create',
            baseUrl: this.apiList.oldConsole,
            method: 'post',
            data: params.data,
            qs: params.params,
            options: {
                isJSON: true
            }
        };
        var callback = function(res) {
            if(!res) {
                res.webstatus = 500;
                res.msg = 'Internal Server Error!!';
            }

            //接口请求失败转换
            if (res.status !== 0) {
                res.code = 201;
                res.msg = res.message;
            }
            return res;
        };
        return this.basicAjax(data, callback);
    }
}
